module.exports = __webpack_public_path__ + "static/media/fa-regular-400.27e9ca4e.svg";